/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Accountingcategory_Undefined10Inputs */



/**

* @param {_Field__Enum_Accountingcategory_Undefined10Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_accountingcategory_undefined10 = /** @type {((inputs?: _Field__Enum_Accountingcategory_Undefined10Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Accountingcategory_Undefined10Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Nicht zugeordnet")
});
export { _field__enum_accountingcategory_undefined10 as "_field__enum_accountingCategory_UNDEFINED" }